import { NamingConfig } from '@shared/naming/naming-config';

/**
 * `IrtWorkflowRun` shape as returned by the hand-written
 * `irt-workflow-runs.gql.ts` documents (no generated `@schema` types exist for
 * these yet, so this is typed by hand, matching `IRT_OUTGOING_WORKFLOW_RUN_FIELDS`).
 */
export interface IrtWorkflowRun {
  id: string;
  runAt: string;
  finishedAt?: string | null;
  status: string;
  trigger: string;
  isTest: boolean;
  workflowId: string;
  workflowName: string;
  internalEventId?: string | null;
  internalEventName?: string | null;
  errorMessage?: string | null;
  retryOf?: string | null;
  /** Only present on the single-run detail query. */
  eventPayload?: string | null;
}

export const IrtWorkflowRunNaming = NamingConfig<IrtWorkflowRun>({
  key: 'IrtWorkflowRun',
  modelName: { '=1': $localize`Workflow Run`, other: $localize`Workflow Runs` },
  fieldNames: {
    id: $localize`ID`,
    runAt: $localize`Run At`,
    finishedAt: $localize`Finished At`,
    status: $localize`Status`,
    trigger: $localize`Trigger`,
    isTest: $localize`Test`,
    workflowId: $localize`Workflow ID`,
    workflowName: $localize`Workflow`,
    internalEventId: $localize`Event ID`,
    internalEventName: $localize`Event`,
    errorMessage: $localize`Error`,
    retryOf: $localize`Retry Of`,
    eventPayload: $localize`Event Payload`,
  },
});
